export default "__VITE_ASSET__814d7448__"